import { useQuery } from "@tanstack/react-query";
import { fetchAvimarkAccountStatus, type AvimarkAccountStatus } from "@common/lib/api/avimarkEditor";
import { useAccountContext } from "@/state/providers/AccountProvider";

/**
 * yes / no / error. On error callers must not guess (never fall back to ExportSettingsModal).
 * `enabled: false` skips the server check (the caller already knows the answer is no).
 */
export function useIsHappyBridgeAvimark(enabled = true): {
    status: AvimarkAccountStatus | "loading";
    refetch: () => void;
} {
    const { accountData } = useAccountContext();
    const q = useQuery({
        queryKey: ["avimark-account-status", accountData?.id ?? ""],
        queryFn: fetchAvimarkAccountStatus,
        enabled: enabled && !!accountData?.id,
        staleTime: 5 * 60 * 1000,
    });
    return { status: q.data ?? "loading", refetch: () => void q.refetch() };
}
